<section role="region" class="wrapper--bg">
  <header role="banner" class="card register-confirmation__header" id="confirmation-title">
    <app-checkmark-loader
      *ngIf="(secureSpaceVisited$ | async) !== 'visited'"
      class="loader"
      [loading]="loading$ | async"
    ></app-checkmark-loader>
    <h1 role="heading" class="register-confirmation__header__title">
      Merci pour votre engagement pour la jeunesse&nbsp;!
    </h1>
    <p>
      <span
        *ngIf="(secureSpaceVisited$ | async) !== 'visited'"
        [style.font-weight]="(isMobile$ | async) ? 'normal' : 'bold'"
      >
        Vous allez recevoir par email l&apos;ensemble des outils mis à disposition pour vous accompagner dans cette
        mobilisation.
      </span>
      Vous pouvez modifier les informations saisies dans le formulaire via le lien que vous avez reçu par email ou en
      <a
        [routerLink]="['/', FeaturesRoutingEnum.Companies, companyId$ | async, CompaniesRoutingEnum.SecureSpace]"
        [queryParams]="queryParamsCompanyToken$ | async"
        aria-label="Lien pour etre redirigé vers le formulaire de modification 'les entreprises s'engagent'"
        class="link--primary"
      >
        cliquant ici
      </a>
    </p>
  </header>
</section>
<section role="region" class="register-confirmation__content">
  <h2 role="heading" class="register-confirmation__content__title">
    <span class="line-break"> Pour concrétiser votre engagement,</span>
    <span class="register-confirmation__content__title--spacing">plusieurs solutions s&apos;offrent à vous&nbsp;:</span>
  </h2>
  <ul class="register-confirmation__content__cards">
    <li class="card register-confirmation__content__card">
      <h3 role="heading" class="register-confirmation__content__card__title">
        Déposer vos offres d&apos;emploi sur la plateforme #1jeune1solution.
      </h3>
      <a
        class="btn-clean btn"
        target="_blank"
        aria-label="Bouton pour déposer une offre"
        [routerLink]="['/', FeaturesRoutingEnum.Jobs, JobsRoutingEnum.Offer]"
        (click)="trackEvent({ category: 'Formulaire Engagement', action: 'Click Dépôt Offre', type: 'navigation' })"
      >
        Je dépose une offre
      </a>
      <p class="register-confirmation__content__card__text">
        J&apos;ai beaucoup d&apos;offres d&apos;emploi,&nbsp;
        <button
          type="button"
          class="btn-clean link--primary"
          (click)="
            openContactForm({
              recipientEmail: 'entreprises@1jeune1solution.fr',
              trackEventAction: 'Click Contact Dépôt'
            })
          "
          aria-label="Bouton permettant de prendre contact avec UnJeuneUneSolution via une modale de contact"
        >
          je prends contact
        </button>
        pour les diffuser automatiquement
      </p>
    </li>
    <li class="card register-confirmation__content__card">
      <h3 role="heading" class="register-confirmation__content__card__title">
        Créer votre page entreprise dédiée détaillant vos actions en faveurs de la jeunesse.
      </h3>
      <a
        class="btn-clean btn"
        aria-label="Bouton je crée ma page entreprise"
        [routerLink]="['/', FeaturesRoutingEnum.Companies, companyId$ | async, CompaniesRoutingEnum.SecureSpace]"
        [queryParams]="queryParamsCompanyToken$ | async"
        (click)="trackEvent({ category: 'Formulaire Engagement', action: 'Click Crée Ma Page', type: 'navigation' })"
      >
        Je créé ma page entreprise
      </a>
      <p class="register-confirmation__content__card__text">
        Je souhaite
        <button
          type="button"
          class="btn-clean link--primary"
          (click)="
            openContactForm({
              recipientEmail: 'entreprises@1jeune1solution.fr',
              trackEventAction: 'Click Contact Page'
            })
          "
          aria-label="Lien pour être recontacté via une modale de contact"
        >
          être recontacté
        </button>
        pour avoir plus d&apos;informations concernant les pages entreprises
      </p>
    </li>
  </ul>
  <div class="card register-confirmation__content__card register-confirmation__content__card--socials">
    <p class="register-confirmation__content__card__title">
      Vous pouvez également communiquer votre engagement sur les réseaux sociaux
    </p>
    <ul class="register-confirmation__social-icons">
      <li *ngFor="let social of socials$ | async; trackBy: trackBySocials">
        <a
          class="register-confirmation__social-icons__item"
          target="_blank"
          [attr.aria-label]="'Lien pour partager sur ' + social.label"
          [href]="social.redirectUrl"
          (click)="
            trackEvent({ category: 'Formulaire Engagement', action: 'Click Partage ' + social.label, type: 'action' })
          "
        >
          <mat-icon
            [svgIcon]="social.icon"
            [ngStyle]="social.margin"
            [attr.aria-label]="'Icône de' + social.label"
          ></mat-icon>
        </a>
      </li>
    </ul>
  </div>
</section>
